// - TODO
// - Flatten state more?

import { get } from "lodash";
import { PROJECT_WIZARD } from "./projectWizardConstants.js";

const INITIAL = {
  projectId: null,
  isError: false,
  isSubmitting: false,
  isComplete: false,
  lastCreated: null // using this for update dependency seems brittle.
};

export const projectWizardReducer = (state = INITIAL, action) => {
  switch (action.type) {
    case PROJECT_WIZARD.POST:
      return {
        ...state,
        isSubmitting: true,
        lastCreated: null
      };

    case PROJECT_WIZARD.FAILURE:
      return {
        ...state,
        isError: true,
        isSubmitting: false,
        isComplete: false,
        lastCreated: null
      };

    case PROJECT_WIZARD.POST_COMPLETE:
      const lastCreated = get(action, "payload.@id", null);
      return {
        ...state,
        isSubmitting: false,
        isComplete: true,
        lastCreated
      };

    case PROJECT_WIZARD.RESET:
      return INITIAL;

    default:
      return state;
  }
};

export default {};
